import { useState } from 'react';
import { Box, Flex } from 'reflexbox';

import { Editable, Heading, Paragraph } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';
import useLocalizedState from 'packages/kakapo-ui-application/hooks/useLocalizedState';

export default function FeedbackTemplateDescription(props: {
	title: string;
	value: graphql.LocalizedAttributedString;
	onChange: (description: graphql.LocalizedAttributedString) => Promise<void>;
}) {
	const [description, setDescription] = useState(props.value);
	const [localizedDescription, setLocalizedDescription] = useLocalizedState(
		description,
		setDescription,
	);

	return (
		<Box flexGrow={1} flexShrink={1} flexBasis={0}>
			<Editable.Quill.Button
				value={localizedDescription}
				onChange={async (description) => {
					await props.onChange(await setLocalizedDescription(description));
				}}
			>
				{(value, { button }) => (
					<>
						<Flex mb={2} alignItems="center">
							<Heading flexGrow={1} flexShrink={1}>
								{props.title}
							</Heading>
							<Box flexGrow={0} flexShrink={0}>
								{button}
							</Box>
						</Flex>
						<Paragraph>{value}</Paragraph>
					</>
				)}
			</Editable.Quill.Button>
		</Box>
	);
}

function FeedbackTemplateDescriptionSkeleton(props: { title: string }) {
	return (
		<Box flexGrow={1} flexShrink={1} flexBasis={0}>
			<Flex mb={2} alignItems="center">
				<Heading flexGrow={1} flexShrink={1}>
					{props.title}
				</Heading>
			</Flex>
			<Paragraph.Skeleton lines={3} width="100%" />
		</Box>
	);
}

FeedbackTemplateDescription.Skeleton = FeedbackTemplateDescriptionSkeleton;
